var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cap-center"},[(_vm.feedback)?_c('p',{staticClass:"feedback"},[_vm._v(_vm._s(_vm.feedback))]):_c('div',{staticClass:"preload-spinner preload-small border-highlight"})])}
var staticRenderFns = []

export { render, staticRenderFns }